import { ArrowUpTrayIcon } from "@sortera/react-icons";
import { unpublishedText } from "../project-header/index.ts";
import styles from "./publish-pill.module.css";

export interface PublishPillProps {
  /** Saves not in the test environment yet. The pill shows only when there are some. */
  unpublished: number;
  publishing: boolean;
  onPublish: () => void;
}

/** "Lägg upp i testmiljön", small beside the month's usage while there is something to publish. */
export function PublishPill({ unpublished, publishing, onPublish }: PublishPillProps) {
  if (unpublished === 0 && !publishing) return null;

  return (
    <button type="button" className={styles.pill} disabled={publishing} onClick={onPublish} title={unpublishedText(unpublished)}>
      <ArrowUpTrayIcon size={14} />
      {publishing ? "Lägger upp…" : "Lägg upp i testmiljön"}
      {!publishing && <span className={styles.count}>{unpublished}</span>}
    </button>
  );
}
